import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.project.BillAddress')
export class BillAddress extends AbstractModel {

    @JsonProperty(String, 'id')
    id: string;

    @JsonProperty(String, 'city')
    city?: string;

    @JsonProperty(String, 'country')
    country?: string;

    @JsonProperty(String, 'countrySubDivisionCode')
    countrySubDivisionCode?: string;

    @JsonProperty(String, 'postalCode')
    postalCode?: string;

    @JsonProperty(String, 'line1')
    line1?: string;

    @JsonProperty(String, 'line2')
    line2?: string;

    @JsonProperty(String, 'line3')
    line3?: string;

    @JsonProperty(String, 'line4')
    line4?: string;

    @JsonProperty(String, 'line5')
    line5?: string;
}
